import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services/api';

export type SearchedPatient = {
  next_appointment_date: string | null;
  past_appointment_date: string | null;
  patient_Name: string;
  patient_birth_date: string;
  patient_id: number;
  ehr_id: string;
};

export type GetPatientListResponse = {
  patients: SearchedPatient[];
};

export type UseGetPatientListParams = {
  search?: string;
};

export const useGetPatientList = ({ search = '' }: UseGetPatientListParams) => {
  const { data: allPatients, ...rest } = useQuery({
    queryKey: ['patients'],
    queryFn: () =>
      api
        .get<GetPatientListResponse>('/v2/patients')
        .then((response) => response.data.patients),
    staleTime: 1000 * 60 * 1, // 1 minute
  });

  const data = allPatients?.filter((patient: SearchedPatient) => {
    return (
      patient.patient_Name.trim() &&
      (patient.patient_Name.toLowerCase().includes(search.toLowerCase()) ||
        String(patient.patient_id)
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        String(patient.ehr_id).toLowerCase().includes(search.toLowerCase()))
    );
  });

  return { data, ...rest };
};
